import React, { Component } from 'react';
import PropTypes from 'prop-types';
import observeRootStore from '../../../components/hoc/observeRootStore';
import { SELECTED_CLASS } from '../../../appConstants';

class StateGroup extends Component {
    selectState = e => {
        const { state, rootStore } = this.props;
        const selectedState =
            rootStore.opsMapCountries[rootStore.uiStore.activeMap][state.gid];
        const currentState = rootStore.uiStore.selectedState;
        rootStore.uiStore.selectedState =
            !currentState || currentState.gid !== e.currentTarget.id
                ? selectedState
                : null;
    };

    render() {
        const { state, rootStore } = this.props;
        const selectedClass = rootStore.uiStore.selectedState
            ? state.gid === rootStore.uiStore.selectedState.gid
            : false;

        return state.hasDetails ? (
            <g
                id={state.gid}
                onClick={this.selectState}
                className={`has-details ${selectedClass ? SELECTED_CLASS : ''}`}
            >
                {this.props.children}
            </g>
        ) : (
            <g id={state.gid}>{this.props.children}</g>
        );
    }
}

StateGroup.propTypes = {
    state: PropTypes.shape({
        gid: PropTypes.string.isRequired,
        hasDetails: PropTypes.bool.isRequired,
    }).isRequired,
    rootStore: PropTypes.shape({
        opsMapCountries: PropTypes.object.isRequired,
        uiStore: PropTypes.shape({
            activeMap: PropTypes.string.isRequired,
            selectedState: PropTypes.shape({
                gid: PropTypes.string,
            }),
        }).isRequired,
    }).isRequired,
    children: PropTypes.node,
};

export default observeRootStore(StateGroup);
